module.exports = __webpack_public_path__ + "static/media/rumble.dfaf5332.png";